module.exports = __webpack_public_path__ + "static/media/message-read.b5fb7297.svg";